/** @format */

import Moment from 'moment';
import { useTranslation } from 'react-i18next/hooks';
import React, { useEffect, useCallback } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';

import { SameTrip } from '../../utils/Utils.js';
import DatePickerTravel from './DatePickerTravel';

function TravelSelect(props) {
	const [t] = useTranslation('translation');

	const setTravelOut = useStoreActions((actions) => actions.cart.setTravelOut);
	const setLastClickedTravel = useStoreActions((actions) => actions.travelsSelect.setLastClickedTravel);
	const cart = useStoreState((state) => state.cart);

	function getClass(trip) {
		const selectedClass = SameTrip(trip, cart.travelOut) ? 'selected' : '';
		const notReservableClass = trip.isReservable ? '' : 'notReservable';
		const expandedClass = !trip.isReservable && SameTrip(trip, props.lastClickedTravel) ? 'expanded' : '';
		return selectedClass + ' ' + notReservableClass + ' ' + expandedClass;
	}

	const handleOnClick = useCallback(
		(trip) => {
			setLastClickedTravel(trip);
			if (trip.isReservable) {
				setTravelOut(trip);
			}
		},
		[setLastClickedTravel, setTravelOut]
	);

	useEffect(() => {
		if (props.travels?.length === 1) handleOnClick(props.travels[0]);
	}, [handleOnClick, props.travels]);

	return (
		<>
			<div className='tripleg'>
				<div>
					<label>{props.stopIdDepartureName}</label>
					<label>{props.stopIdArrivalName}</label>
				</div>
				<div>
					<span className='mappointer1'>
						<span></span>
					</span>
					<div className='arrow'>
						<hr />
					</div>
					<div>
						<hr />
					</div>
					<span className='mappointer2'>
						<span>
							<span></span>
						</span>
					</span>
				</div>
			</div>
			<div className='verticalSpace8' />
			<DatePickerTravel />
			<div className='departurelist active'>
				<table>
					<thead>
						<tr>
							<th style={{ width: '35%' }}>{t('Departure')}</th>
							<th style={{ width: '35%' }}>{t('arrival')}</th>
							<th style={{ width: '30%' }}></th>
						</tr>
					</thead>
					<tbody>
						{props.loading ? (
							<tr className='loading'>
								<td colSpan='4'>{t('loading')}...</td>
							</tr>
						) : props.travels !== null && props.travels.length > 0 ? (
							props.travels.map((x, i) => {
								return (
									<React.Fragment key={i}>
										<tr onClick={(_) => handleOnClick(x)} className={getClass(x)}>
											<td style={{ textTransform: 'capitalize' }}>
												{Moment(x.departure).format('dddd HH:mm')}
											</td>
											<td>{Moment(x.arrival).format('HH:mm')}</td>
											<td style={{ whiteSpace: 'nowrap' }}>
												{t('Route')} {x.routeShortName}
											</td>
										</tr>
										{!x.isReservable && (
											<tr className='warning'>
												<td colSpan='4'>
													{x.isReservableMsg !== null
														? t(x.isReservableMsg)
														: t('The trip can not be booked for unknown reasons')}{' '}
												</td>
											</tr>
										)}
									</React.Fragment>
								);
							})
						) : (
							<tr className='doneLoading'>
								<td colSpan='4'>{t('noAvailableDepartures')}</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</>
	);
}

export default TravelSelect;
